import React, { useState } from 'react';
import { Sparkles, ArrowRight, X } from 'lucide-react';

export default function TopBanner() {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;

  return (
    <div className="relative bg-[#2C3E50] text-[#FFF8EC] border-b-2 border-[#F4B93E]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-2.5 flex items-center justify-center gap-3 text-sm">
        <span className="hidden sm:inline-flex items-center gap-1.5 bg-[#F4B93E] text-[#2C3E50] px-2 py-0.5 rounded-full text-[10px] font-black uppercase tracking-widest">
          <Sparkles size={11} strokeWidth={3} /> New
        </span>
        <span className="font-semibold text-center">
          Admissions open for 2025-26 &middot;{' '}
          <span className="text-[#F4B93E] font-black">FREE Demo Class</span> before you pay
        </span>
        <a
          href="#register"
          className="ml-1 inline-flex items-center gap-1 bg-[#E64B2B] text-white font-black px-3 py-1 rounded-md text-xs uppercase tracking-widest hover:bg-[#F4B93E] hover:text-[#2C3E50]"
        >
          Register Now <ArrowRight size={13} strokeWidth={3} />
        </a>
        <button
          onClick={() => setVisible(false)}
          aria-label="Dismiss"
          className="absolute right-3 top-1/2 -translate-y-1/2 text-[#FFF8EC]/60 hover:text-[#FFF8EC] p-1"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
